import React from 'react';

const LandscapeModal = props => (
    props.display && <section className="landscape-container">
        <div className="landscape-metadata-container">
            <h1>My Wayfinder</h1>
            <p>Rotate your device to experience My Wayfinder</p>
            <img src="/images/rotate-phone.png" alt="Rotate your phone to portrait mode"/>
        </div>
    </section>
);

export default LandscapeModal;
